export const DEFAULT_ERROR_MESSAGE = 'No se han podido cargar más elementos.'
export const DEFAULT_RETRY_LABEL = 'Reintentar'
export const DEFAULT_LOADING_LABEL = 'Cargando más elementos'
